var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteAnnouncements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 48,
    viewBox: "0 0 39 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.8V37.2H5.11875V18.84C5.11875 15.56 6.12422 12.59 8.13516 9.93C10.1461 7.27 12.7969 5.6 16.0875 4.92V3.18C16.0875 2.26 16.4227 1.5 17.093 0.9C17.7633 0.3 18.5656 0 19.5 0C20.4344 0 21.2367 0.3 21.907 0.9C22.5773 1.5 22.9125 2.26 22.9125 3.18V4.92C26.2031 5.6 28.8641 7.27 30.8953 9.93C32.9266 12.59 33.9422 15.56 33.9422 18.84V37.2H39V40.8H0ZM19.5 48C18.2 48 17.0625 47.53 16.0875 46.59C15.1125 45.65 14.625 44.52 14.625 43.2H24.375C24.375 44.52 23.8977 45.65 22.943 46.59C21.9883 47.53 20.8406 48 19.5 48Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteAnnouncements);
export default __webpack_public_path__ + "static/media/whiteAnnouncements.95f2d6dd94e964d5bca8b229d21d48a2.svg";
export { ForwardRef as ReactComponent };